// i18n — lightweight FI/EN translation dictionary + hook.
import { useCalculatorStore } from "@/store/calculatorStore";

export const translations = {
  fi: {
    "app.subtitle": "MIL / MOA Ilma-ase tarkkuusinstrumentti · v2.4",
    "header.setLocation": "Aseta sijainti",
    "header.gps": "GPS",
    "header.temp": "Lämpö",
    "header.altitude": "Korkeus",
    "header.airDensity": "Ilmantiheys",

    "metrics.e0": "Lähtöenergia E0",
    "metrics.e0sub": "Piipun suulla",
    "metrics.residual": "Jäännösenergia",
    "metrics.windDrift": "Tuuliajautuma",
    "metrics.flightTime": "Lennon kesto",

    "input.pelletProfile": "Pelletti & Aseprofiili",
    "input.selectPellet": "Valitse Pelletti",
    "input.mass": "Luodin paino",
    "input.v0": "Lähtönopeus V0",
    "input.bc": "Ballistinen kerroin (G1)",
    "input.opticsZero": "Optiikka & Kohdistus",
    "input.zeroDistance": "Kohdistusetäisyys",
    "input.targetDistance": "Kohde-etäisyys",
    "input.sightHeight": "Kiikarin korkeus",
    "input.inclination": "Ammuntakulma",
    "input.windEnv": "Tuuli & Ympäristö",
    "input.windSpeed": "Tuulen nopeus",
    "input.windDir": "Tuulen suunta",
    "input.temp": "Lämpötila",
    "input.altitude": "Korkeus mpy",
    "input.holdoverUnit": "Lentoratayksikkö & Klikit",
    "input.clickValue": "Klikin arvo (rykmentti)",
    "input.profiles": "Profiilit (tallennus)",
    "input.profileName": "Profiilin nimi",
    "input.save": "Tallenna",
    "input.load": "Lataa",
    "input.reset": "Nollaa syötteet",

    "chart.title": "Lentorata · Pudotus",
    "chart.overlayLabel": "Ylälinja",
    "chart.overlayNone": "Ei",
    "chart.velocity": "Nopeus",
    "chart.energy": "Energia",
    "chart.distance": "Etäisyys",
    "chart.tt.drop": "Pudotus",
    "chart.tt.correction": "Korjaus",
    "chart.tt.velocity": "Nopeus",
    "chart.tt.energy": "Energia",
    "chart.tt.time": "Aika",

    "reticle.title": "Tähtäinnäkymä · Klikkikartta",
    "reticle.elevation": "Korotus (Holdover)",
    "reticle.windage": "Tuulikorjaus (Windage)",
    "reticle.clicks": "klikkiä",

    "table.title": "Ballistiikkakortti",
    "table.distance": "Etäis.",
    "table.drop": "Pudotus",
    "table.correction": "Korjaus",
    "table.clicks": "Klikit",
    "table.wind": "Tuuli",
    "table.velocity": "Nopeus",
    "table.energy": "Energia",
    "table.time": "Aika",

    "dir.up": "YLÖS",
    "dir.down": "ALAS",
    "dir.leftFull": "VASEMMALLE",
    "dir.rightFull": "OIKEALLE",
    "dir.right": "OIK",
    "dir.left": "VAS",

    "footer": "DASE Ballistics · G1 pistemassaratkaisija · Ilma-asetarkkuus · Tiedot tallennetaan paikallisesti selaimeen",

    "toast.pelletSelected": "Pelletti valittu",
    "toast.profileSaved": "Profiili tallennettu",
    "toast.loaded": "Ladattu",
    "toast.reset": "Syötteet palautettu oletuksiin",
    "toast.gpsSet": "Sijainti asetettu GPS:llä",
    "toast.gpsError": "GPS ei saatavilla",
    "toast.gpsWait": "Haetaan sijaintia…",

    "header.searchHint": "Enter = hae paikka nimellä",
    "toast.weatherSet": "Sää ja sijainti päivitetty",
    "toast.locNotFound": "Paikkaa ei löytynyt",
    "toast.weatherFail": "Sään haku epäonnistui",

    "chart.wind": "Tuuli",

    "mpbr.title": "MPBR · Suurin suora ampumamatka",
    "mpbr.vitalWindow": "Osumaikkuna (halkaisija)",
    "mpbr.nearZero": "Lähinolla",
    "mpbr.farZero": "Optimikohdistus",
    "mpbr.mpbr": "MPBR (max)",
    "mpbr.maxOrd": "Suurin nousu",
    "mpbr.hint": "Suurin etäisyys jolla osuma pysyy ±ikkunan sisällä ilman korotusta.",

    "export.csv": "CSV",
    "export.pdf": "PDF",
    "export.done": "Kortti viety",
    "export.pellet": "Pelletti",
    "export.v0": "Lähtönopeus",
    "export.bc": "BC (G1)",
    "export.zero": "Kohdistus",
    "export.target": "Kohde",
    "export.wind": "Tuuli",
    "export.temp": "Lämpötila",
    "export.location": "Sijainti",
    "export.generated": "Luotu",
  },
  en: {
    "app.subtitle": "MIL / MOA Airgun Precision Instrument · v2.4",
    "header.setLocation": "Set location",
    "header.gps": "GPS",
    "header.temp": "Temp",
    "header.altitude": "Altitude",
    "header.airDensity": "Air density",

    "metrics.e0": "Muzzle energy E0",
    "metrics.e0sub": "At the muzzle",
    "metrics.residual": "Residual energy",
    "metrics.windDrift": "Wind drift",
    "metrics.flightTime": "Flight time",

    "input.pelletProfile": "Pellet & Rifle Profile",
    "input.selectPellet": "Select Pellet",
    "input.mass": "Projectile mass",
    "input.v0": "Muzzle velocity V0",
    "input.bc": "Ballistic coefficient (G1)",
    "input.opticsZero": "Optics & Zero",
    "input.zeroDistance": "Zero distance",
    "input.targetDistance": "Target distance",
    "input.sightHeight": "Scope height",
    "input.inclination": "Shot angle",
    "input.windEnv": "Wind & Atmosphere",
    "input.windSpeed": "Wind speed",
    "input.windDir": "Wind direction",
    "input.temp": "Temperature",
    "input.altitude": "Altitude ASL",
    "input.holdoverUnit": "Holdover Unit & Clicks",
    "input.clickValue": "Click value (turret)",
    "input.profiles": "Profiles (saved)",
    "input.profileName": "Profile name",
    "input.save": "Save",
    "input.load": "Load",
    "input.reset": "Reset inputs",

    "chart.title": "Trajectory · Drop",
    "chart.overlayLabel": "Overlay",
    "chart.overlayNone": "Off",
    "chart.velocity": "Velocity",
    "chart.energy": "Energy",
    "chart.distance": "Distance",
    "chart.tt.drop": "Drop",
    "chart.tt.correction": "Correction",
    "chart.tt.velocity": "Velocity",
    "chart.tt.energy": "Energy",
    "chart.tt.time": "Time",

    "reticle.title": "Scope View · Click Map",
    "reticle.elevation": "Elevation (Holdover)",
    "reticle.windage": "Windage",
    "reticle.clicks": "clicks",

    "table.title": "Ballistic Card",
    "table.distance": "Dist.",
    "table.drop": "Drop",
    "table.correction": "Correction",
    "table.clicks": "Clicks",
    "table.wind": "Wind",
    "table.velocity": "Velocity",
    "table.energy": "Energy",
    "table.time": "Time",

    "dir.up": "UP",
    "dir.down": "DOWN",
    "dir.leftFull": "LEFT",
    "dir.rightFull": "RIGHT",
    "dir.right": "R",
    "dir.left": "L",

    "footer": "DASE Ballistics · G1 point-mass solver · Airgun precision · Data stored locally in your browser",

    "toast.pelletSelected": "Pellet selected",
    "toast.profileSaved": "Profile saved",
    "toast.loaded": "Loaded",
    "toast.reset": "Inputs reset to defaults",
    "toast.gpsSet": "Location set from GPS",
    "toast.gpsError": "GPS unavailable",
    "toast.gpsWait": "Locating…",

    "header.searchHint": "Enter = search location by name",
    "toast.weatherSet": "Weather & location updated",
    "toast.locNotFound": "Location not found",
    "toast.weatherFail": "Weather fetch failed",

    "chart.wind": "Wind",

    "mpbr.title": "MPBR · Max Point-Blank Range",
    "mpbr.vitalWindow": "Hit window (diameter)",
    "mpbr.nearZero": "Near zero",
    "mpbr.farZero": "Optimal zero",
    "mpbr.mpbr": "MPBR (max)",
    "mpbr.maxOrd": "Max ordinate",
    "mpbr.hint": "Farthest range where the hit stays within ±window with no holdover.",

    "export.csv": "CSV",
    "export.pdf": "PDF",
    "export.done": "Card exported",
    "export.pellet": "Pellet",
    "export.v0": "Muzzle velocity",
    "export.bc": "BC (G1)",
    "export.zero": "Zero",
    "export.target": "Target",
    "export.wind": "Wind",
    "export.temp": "Temperature",
    "export.location": "Location",
    "export.generated": "Generated",
  },
};

export function useT() {
  const lang = useCalculatorStore((s) => s.language);
  return (key) =>
    (translations[lang] && translations[lang][key]) ??
    translations.fi[key] ??
    key;
}

export function tFor(lang, key) {
  return (translations[lang] && translations[lang][key]) ?? translations.fi[key] ?? key;
}
